import cn from 'classnames'

import Button from '@components/Button'
import TermsAndConditionsCheckbox from '@components/TermsAndConditionsCheckbox'
import { RateCurrency } from 'shared/price-utilities'

import styles from './styles.module.scss'

const TermsLabelText = () => (
    <div className={styles.termsConditionsLink}>
        <T>subscription.purchase.terms.conditions.label</T>
        <Link
            to="/terms-and-conditions"
            className={cn('ml-1', styles.termsConditionsLink)}
            target="_blank"
            rel="noopener noreferrer">
            <T>subscription.purchase.terms.conditions.link</T>
        </Link>
    </div>
)

const FooterSection = ({
    totalValue,
    currencySymbol,
    loading,
    disabled,
    termsAccepted,
    setTermsAccepted,
    termsError,
}) => {
    const acceptTermsHandler = event => {
        const { checked } = event?.target

        setTermsAccepted(checked)
    }

    return (
        <div>
            <div className="mb-3 d-flex align-items-baseline justify-content-sm-end">
                <span className="mr-1">
                    <T>subscripition.purchase.pay.label.total</T>
                </span>
                <h3 className="ml-2 ">
                    <RateCurrency value={totalValue} currency={currencySymbol} />
                </h3>
            </div>
            <div className="d-sm-flex justify-content-between align-items-center">
                <TermsAndConditionsCheckbox checked={termsAccepted} onChange={acceptTermsHandler} error={termsError}>
                    <TermsLabelText />
                </TermsAndConditionsCheckbox>
                <Button isLoading={loading} btnStyle="primary" type="submit" disabled={disabled}>
                    <T>subscription.purchase.label.buy</T>
                </Button>
            </div>
        </div>
    )
}

export default FooterSection
